import { useGcal } from '..';
import React from 'react';
interface GcalAuthenticatedProps {
  roles?: string[];
  element: React.ReactElement;
}

/**
 * Renders element if gcal authenticated and user has enough permission
 * @param roles if specified, restricts element only to users with one of given roles
 * @param element react Node to render
 */
export function GcalAuthenticated({ roles, element }: GcalAuthenticatedProps) {
  const { user, groups } = useGcal();
  if (!user) {
    return null;
  }
  if (
    roles &&
    !roles.some((element) => {
      return groups?.includes(element);
    })
  )
    return null;

  return element;
}
